import React from 'react'
import Layout from '../../features/layout'
import CareerPage from '../../templates/careerPage/components/CareerPage'

const CareersJobPage = ({ location, params }) => {
  const appPath = params['*'] || ''

  return (
    <Layout>
      <CareerPage jobSlug={appPath} location={location} />
    </Layout>
  )
}

export default CareersJobPage
